var map = {
	"./1.png": "Txl5",
	"./222.png": "XboF",
	"./Contact-info.png": "jGXK",
	"./Contact.png": "QCTk",
	"./Testimonial.png": "bGw/",
	"./Testimonial1.png": "XiGS",
	"./Testimonial2.png": "tH18",
	"./about-bg.png": "j313",
	"./aboutus.png": "6uiW",
	"./app/1.jpg": "yZ2I",
	"./app/10.jpg": "8aBu",
	"./app/11.jpg": "1IZE",
	"./app/12.jpg": "kvhG",
	"./app/13.jpg": "AQC5",
	"./app/14.jpg": "osO2",
	"./app/15.jpg": "SWZ5",
	"./app/16.jpg": "5VkT",
	"./app/17.jpg": "ORmL",
	"./app/2.jpg": "RYWd",
	"./app/3.jpg": "wBqP",
	"./app/4.jpg": "VdFB",
	"./app/5.jpg": "mwEt",
	"./app/6.jpg": "Nv0Y",
	"./app/7.jpg": "FYhk",
	"./app/8.jpg": "arkn",
	"./app/9.jpg": "LUKC",
	"./appstore.png": "Rf8H",
	"./auth-bg.jpg": "9lqd",
	"./auth-bg.png": "d7Qf",
	"./avtar/1.jpg": "F80L",
	"./avtar/15.jpg": "OPXd",
	"./avtar/22.jpg": "sDxD",
	"./back.png": "DtD7",
	"./blog/1.jpg": "LA5K",
	"./blog/10.jpg": "OeJB",
	"./blog/2.jpg": "8ZQi",
	"./blog/3.jpg": "gp7d",
	"./blog/6.jpg": "jtnm",
	"./blog/7.jpg": "uH2u",
	"./blog/8.jpg": "URVa",
	"./blog/9.jpg": "uwYJ",
	"./blog/blog-comment-three.jpg": "3//O",
	"./blog/blog-comment-two.jpg": "P7ej",
	"./blog/blog-comment.jpg": "Quc0",
	"./blog/blog-details.jpg": "49OC",
	"./blog/blog3.jpg": "4fKA",
	"./browsers/chrome.png": "iB4l",
	"./browsers/firefox.png": "yOtu",
	"./browsers/ie.png": "uqIx",
	"./browsers/opera.png": "xqxY",
	"./browsers/safari.png": "OAVQ",
	"./color/color-2/1.png": "07YU",
	"./color/color-2/Homev1.png": "1RwD",
	"./color/color-2/Homev2.png": "GeOB",
	"./color/color-2/Homev3.png": "f/Y6",
	"./color/color-2/Testimonial.png": "iV9z",
	"./color/color-2/about-bg.png": "F0os",
	"./color/color-2/contact.png": "0rda",
	"./color/color-2/feature-bg1.png": "dcWM",
	"./color/color-2/price-bg.png": "x+rf",
	"./color/color-2/price.png": "RMD0",
	"./color/color-2/screenshot-bg.png": "M8Po",
	"./color/color-2/team-bg.png": "DF6a",
	"./color/color-2/team-img-bg.png": "A/Yg",
	"./color/color-3/1.png": "n2Jb",
	"./color/color-3/Homev2.png": "yAkE",
	"./color/color-3/Homev3.png": "5ewK",
	"./color/color-3/Testimonial.png": "fkqU",
	"./color/color-3/about-bg.png": "2u8l",
	"./color/color-3/contact.png": "PUbw",
	"./color/color-3/feature-bg1.png": "mhk0",
	"./color/color-3/price-bg.png": "a1w3",
	"./color/color-3/price.png": "emvA",
	"./color/color-3/screenshot-bg.png": "6iEg",
	"./color/color-3/team-bg.png": "ksU0",
	"./color/color-3/team-img-bg.png": "SJqP",
	"./color/color-3/testimonial-bg.png": "Y3RR",
	"./demo/404.png": "tws9",
	"./demo/blog-details-with-leftsidebar.jpg": "ZiR9",
	"./demo/blog-details-with-rightsidebar.jpg": "iFDl",
	"./demo/blog-details.jpg": "sAU5",
	"./demo/blog.jpg": "cwzX",
	"./demo/blogs-leftside.jpg": "dNFu",
	"./demo/blogs-rightside.jpg": "rjGn",
	"./demo/coming-soon.png": "MnSi",
	"./demo/download.png": "/POV",
	"./demo/email.png": "h78I",
	"./demo/faq.png": "AXP+",
	"./demo/forget-pwd.png": "06Ea",
	"./demo/index-2.jpg": "g71+",
	"./demo/index-3.jpg": "Xgz1",
	"./demo/index.jpg": "M7fv",
	"./demo/review.png": "B7aC",
	"./demo/sign-in.png": "b5fc",
	"./demo/sign-up.png": "teDP",
	"./demo/thank-you.png": "6akV",
	"./down.png": "rix4",
	"./echodot.jpg": "JM3i",
	"./echodot.png": "uG8G",
	"./echospot.png": "G96s",
	"./echospot2.png": "kpj/",
	"./email.png": "vCvB",
	"./email/facebook-email.png": "8Lla",
	"./email/feed.png": "I5gV",
	"./email/google.png": "oUd3",
	"./email/instagram-email.png": "gJwI",
	"./email/twitter-email.png": "tKhp",
	"./error/cloud-bg-1.png": "CQE+",
	"./error/cloud-bg-2 - Copy.png": "M8Pn",
	"./error/cloud-bg-2.png": "q/eM",
	"./error/sad.png": "a2bI",
	"./escapeshow.png": "kYyx",
	"./favicon-16x16.png": "n4VC",
	"./favicon-32x32.png": "dmYh",
	"./favicon.ico": "IymD",
	"./favicon.png": "1H3f",
	"./fax.png": "vBzX",
	"./feature-bg.png": "Xhqm",
	"./feature-circle-two.png": "KZrA",
	"./feature-circle.png": "mkW3",
	"./feature2.png": "fnNz",
	"./features/all-broweser-support.png": "cvPG",
	"./features/animate-css.png": "dDoi",
	"./features/bootstrap-4.png": "5slL",
	"./features/color-management.png": "MnNr",
	"./features/css-3.png": "dBHD",
	"./features/fullpage-js.png": "kppf",
	"./features/google-fonts-support.png": "Y2nW",
	"./features/google-map.png": "UT53",
	"./features/html5.png": "CRM7",
	"./features/multiple-blog-layouts.png": "Dy2W",
	"./features/pixel-perfect-design.png": "w5QQ",
	"./features/responsive.png": "ZQ0r",
	"./features/social-links.png": "tB4H",
	"./features/three-type-home-page.png": "Qds5",
	"./features/typography.png": "jGQG",
	"./features/vue.png": "8NSn",
	"./features/w3c-validation.png": "XMwm",
	"./fotter-email.png": "phIc",
	"./home2/home2-slider.png": "s6ax",
	"./home2/logo-icon.png": "rmmc",
	"./home2/logo.png": "ZVat",
	"./home2/play-button.png": "BZ8Q",
	"./home2/slider-caption.png": "IXWz",
	"./home3/home-3-img.png": "QXWg",
	"./home3/home3-slider.png": "4gOx",
	"./icon/1.png": "nYED",
	"./icon/2.png": "XaML",
	"./icon/3.png": "k0u4",
	"./icon/4.png": "AOVd",
	"./icon/5.png": "2d/n",
	"./icon/6.png": "xchJ",
	"./icon1.png": "d0yY",
	"./icon2.png": "ceFa",
	"./icon3.png": "akCb",
	"./icon4.png": "72gb",
	"./instagram.png": "JGRZ",
	"./landing-logo.png": "VZdp",
	"./landing/1.png": "93zg",
	"./landing/2.png": "Zuxj",
	"./landing/3.png": "6PZE",
	"./landing/4.jpg": "ZRV8",
	"./landing/5.jpg": "A1OO",
	"./landing/6.jpg": "vhxb",
	"./landing/template.png": "FeVF",
	"./lannd-bg.png": "DKzj",
	"./light-right.png": "cDCj",
	"./light.png": "77ig",
	"./locate.png": "I7T+",
	"./logo-animatable.svg": "qFUb",
	"./logo.png": "iQH9",
	"./logo.svg": "zxL1",
	"./logoimage.png": "rEiP",
	"./mac.png": "WMFF",
	"./main-banner1.png": "zeIt",
	"./main-banner12.png": "+gyt",
	"./main-banner3.png": "jS8J",
	"./message.png": "Sbtz",
	"./mobile.png": "HXsc",
	"./next.png": "3aVt",
	"./phone.png": "JhOT",
	"./placeholder.png": "JVyh",
	"./play-store.png": "6hIX",
	"./presslogo/amazon.png": "gSUk",
	"./presslogo/cnet.png": "4Lq5",
	"./presslogo/dashbot.png": "ZKNx",
	"./presslogo/homesmart.png": "pG0l",
	"./presslogo/jargon.png": "ddbA",
	"./presslogo/jovo.png": "n02W",
	"./presslogo/tc.png": "aY1k",
	"./price-bg.png": "pR8Y",
	"./price.png": "bt7z",
	"./review-stars.png": "lvUH",
	"./screen1.png": "rkxw",
	"./screenshot-bg.png": "8bdc",
	"./screenshot-mob.png": "AkL+",
	"./square-logo.svg": "CtJ0",
	"./star.png": "FHDy",
	"./team-bg.png": "nW+u",
	"./team-img-bg.png": "ZRVw",
	"./team.png": "QyPm",
	"./team1.png": "wu6y",
	"./team3.png": "1na9",
	"./telephone.png": "W8/8",
	"./testimonial-bg.png": "piVB",
	"./thank-you.png": "191p"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0